import { createContext } from "react";
const OrderSettingContext = createContext({});

export default OrderSettingContext;
